import React from 'react';
import { FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/gqgeGFKyMhfT7rusiCXu5i/payne_equipment_logo.png';
export function Footer() {
  return <footer className="w-full bg-black border-t border-brand-border" role="contentinfo" data-id="element-105">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-106">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-107">
          {/* Column 1 — Logo & Tagline */}
          <div className="lg:col-span-1" data-id="element-108">
            <img src={LOGO_URL} alt="Payne Equipment Sales LLC" className="h-10 w-auto mb-4" data-id="element-109" />
            <p className="text-brand-muted text-sm leading-relaxed mb-4" data-id="element-110">
              Arizona's largest used construction equipment dealer. Serving
              contractors with faith, integrity, and diligence.
            </p>
            <div className="flex items-center gap-4" data-id="element-111">
              <a href="#" className="w-10 h-10 rounded-full bg-brand-card flex items-center justify-center text-brand-muted hover:text-brand-orange hover:bg-brand-card/80 transition-colors min-w-[48px] min-h-[48px]" aria-label="Facebook" data-id="element-112">
                <FacebookIcon className="w-5 h-5" data-id="element-113" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-brand-card flex items-center justify-center text-brand-muted hover:text-brand-orange hover:bg-brand-card/80 transition-colors min-w-[48px] min-h-[48px]" aria-label="Instagram" data-id="element-114">
                <InstagramIcon className="w-5 h-5" data-id="element-115" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-brand-card flex items-center justify-center text-brand-muted hover:text-brand-orange hover:bg-brand-card/80 transition-colors min-w-[48px] min-h-[48px]" aria-label="YouTube" data-id="element-116">
                <YoutubeIcon className="w-5 h-5" data-id="element-117" />
              </a>
            </div>
          </div>

          {/* Column 2 — Quick Links */}
          <div data-id="element-118">
            <h3 className="font-oswald font-semibold text-sm uppercase tracking-wider text-white mb-4" data-id="element-119">
              Quick Links
            </h3>
            <nav aria-label="Footer quick links" data-id="element-120">
              <ul className="space-y-1" data-id="element-121">
                <li data-id="element-122">
                  <a href="#equipment" className="text-brand-muted text-sm hover:text-brand-orange transition-colors inline-flex items-center min-h-[44px]" data-id="element-123">
                    Equipment for Sale
                  </a>
                </li>
                <li data-id="element-124">
                  <a href="#why-pes" className="text-brand-muted text-sm hover:text-brand-orange transition-colors inline-flex items-center min-h-[44px]" data-id="element-125">
                    About PES
                  </a>
                </li>
                <li data-id="element-126">
                  <a href="#reviews" className="text-brand-muted text-sm hover:text-brand-orange transition-colors inline-flex items-center min-h-[44px]" data-id="element-127">
                    Customer Reviews
                  </a>
                </li>
                <li data-id="element-128">
                  <a href="#contact" className="text-brand-muted text-sm hover:text-brand-orange transition-colors inline-flex items-center min-h-[44px]" data-id="element-129">
                    Contact Us
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Column 3 — Equipment */}
          <div data-id="element-130">
            <h3 className="font-oswald font-semibold text-sm uppercase tracking-wider text-white mb-4" data-id="element-131">
              Equipment
            </h3>
            <nav aria-label="Footer equipment links" data-id="element-132">
              <ul className="space-y-1" data-id="element-133">
                <li data-id="element-134">
                  <a href="#" className="text-brand-muted text-sm hover:text-brand-orange transition-colors inline-flex items-center min-h-[44px]" data-id="element-135">
                    Skid Steers
                  </a>
                </li>
                <li data-id="element-136">
                  <a href="#" className="text-brand-muted text-sm hover:text-brand-orange transition-colors inline-flex items-center min-h-[44px]" data-id="element-137">
                    Excavators
                  </a>
                </li>
                <li data-id="element-138">
                  <a href="#" className="text-brand-muted text-sm hover:text-brand-orange transition-colors inline-flex items-center min-h-[44px]" data-id="element-139">
                    Scissor Lifts
                  </a>
                </li>
                <li data-id="element-140">
                  <a href="#" className="text-brand-muted text-sm hover:text-brand-orange transition-colors inline-flex items-center min-h-[44px]" data-id="element-141">
                    Trucks & Trailers
                  </a>
                </li>
                <li data-id="element-142">
                  <a href="#" className="text-brand-muted text-sm hover:text-brand-orange transition-colors inline-flex items-center min-h-[44px]" data-id="element-143">
                    Attachments
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Column 4 — Payment Methods */}
          <div data-id="element-144">
            <h3 className="font-oswald font-semibold text-sm uppercase tracking-wider text-white mb-4" data-id="element-145">
              We Accept
            </h3>
            <div className="flex flex-wrap gap-3 mb-6" data-id="element-146">
              <span className="px-3 py-1.5 bg-brand-card rounded text-brand-muted text-xs font-medium border border-brand-border" data-id="element-147">
                Cash
              </span>
              <span className="px-3 py-1.5 bg-brand-card rounded text-brand-muted text-xs font-medium border border-brand-border" data-id="element-148">
                Check
              </span>
              <span className="px-3 py-1.5 bg-brand-card rounded text-brand-muted text-xs font-medium border border-brand-border" data-id="element-149">
                Wire Transfer
              </span>
              <span className="px-3 py-1.5 bg-brand-card rounded text-brand-muted text-xs font-medium border border-brand-border" data-id="element-150">
                Financing
              </span>
              <span className="px-3 py-1.5 bg-brand-card rounded text-brand-muted text-xs font-medium border border-brand-border" data-id="element-151">
                Credit Card
              </span>
            </div>
            <p className="text-brand-muted text-xs" data-id="element-152">
              Financing available 12–60 months. Subject to credit approval.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-brand-border" data-id="element-153">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left" data-id="element-154">
            <p className="text-brand-muted text-xs" data-id="element-155">
              © {new Date().getFullYear()} Payne Equipment Sales LLC. All
              rights reserved.
            </p>
            <p className="text-brand-muted text-xs italic" data-id="element-156">
              Built on Faith, Integrity & Diligence ✝
            </p>
          </div>
        </div>
      </div>
    </footer>;
}